import { FC } from 'react';
import { Button as AntButton, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onCancel: () => void;
  onOk: () => void;
}

const ConfirmModal: FC<IProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('sms.send.5')}
      {...props}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={props.onOk}
          >
            {t('common.button.confirm')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => props.setVisible(false)}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >

      <p className='text-center mb-0'>{t('sms.send.6')}</p>
    </Modal>
  );
};

export default ConfirmModal;
